import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SelectContainer = styled(Grid)({
  width: "120px",
  paddingLeft: "16px",
});
